module.exports = __webpack_public_path__ + "img/mofocusd_top.42fc91bc.jpg";